import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme/color'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import Badge from '@mui/material/Badge'
import { Route } from './routes'
import { MessagesApi } from '@trivie/core/src/services/api-objects'

const useStyles = makeStyles(() =>
  createStyles({
    navItem: {
      width: '100%',
      cursor: 'pointer',
    },
  }),
)

export const Tabbar = observer((props: any) => {
  const { hide, displayRoutes } = props
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles()
  const { userStore } = useStores()
  const { user, notifications, getNotifications, checkNotifications, enterpriseTier } = userStore

  const [openedDrawer, setOpenedDrawer] = useState<any>(undefined)
  const [notificationData, setNotificationData] = useState(0)

  const [active, setActive] = useState<any>(undefined)

  useEffect(() => {
    displayRoutes.forEach((route: any) => {
      if (location.pathname.includes(route.path)) {
        setActive(route.path)
      }
    })
  }, [location.pathname, displayRoutes, enterpriseTier])

  useEffect(() => {
    displayRoutes.forEach((route: Route) => {
      if (location.pathname.includes(route.path)) {
        setOpenedDrawer(route.path)
      }
    })

    const pr = ['/library', '/play', '/notifications', '/profile']
    const permittedRoutes =
      user?.workspace_settings?.feed_enabled ||
      userStore.user?.workspace_settings?.feed_enabled === undefined
        ? ['talk', ...pr]
        : ['dashboard', ...pr]

    const route = location.pathname

    if (permittedRoutes.includes(route)) {
      if (user) {
        getNotifications(user.id)
      }

      const newNotificationsTotal = notifications?.new?.length + notifications?.priority?.length
      setNotificationData(newNotificationsTotal)
    }

    return () => {
      if (route === '/notifications' && user) {
        MessagesApi.markAllAsRead(user.id)
      }
    }
  }, [location])

  const onNavItemClick = (path: string) => {
    history.push(path)
    setActive(path)
    if (user?.id) {
      checkNotifications(user?.id)
    }
  }

  return (
    <nav style={{ ...NAV, display: hide ? 'none' : 'block' }}>
      <ul style={LIST}>
        {displayRoutes.map((route: any, index: number) => {
          const isOpen = active === route.path
          if (route.name === 'settings') {
            return
          }
          if (
            userStore.user?.workspace_settings?.feed_enabled !== undefined &&
            !userStore.user?.workspace_settings?.feed_enabled
          ) {
            if (route.name === 'talk' || route.name === 'settings' || route.name === 'profile') {
              return
            }
          } else {
            if (route.name === 'dashboard' || route.name === 'profile-alt') {
              return
            }
          }
          return (
            route && (
              <ul
                key={`ROUTE_LIST_${index}`}
                style={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  margin: 0,
                }}
              >
                <li className={classes.navItem} key={`ROUTE_${index}`}>
                  <div
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onNavItemClick(route.path)
                      }
                    }}
                    onClick={() => onNavItemClick(route.path)}
                    style={{
                      ...(isOpen ? ACTIVE_LINK_TOP : LINK),
                      color: isOpen ? color.palette.blueLink : color.shade70,
                    }}
                    role="link"
                    tabIndex={0}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          ...LEFT_BORDER,
                          backgroundColor: isOpen ? 'transparent' : 'initial',
                        }}
                      />
                      {route.label === 'Notifications.header' && notificationData >= 1 ? (
                        <Badge
                          badgeContent={notificationData}
                          sx={{
                            '.MuiBadge-badge': {
                              backgroundColor: color.red,
                              right: 4,
                              top: 2,
                              color: color.white,
                            },
                          }}
                        >
                          {route.icon(isOpen, true)}
                        </Badge>
                      ) : (
                        <>{route.icon(isOpen, true)}</>
                      )}
                    </div>
                  </div>
                </li>
              </ul>
            )
          )
        })}
      </ul>
    </nav>
  )
})

const LINK: React.CSSProperties = {
  textDecoration: 'none',
  alignSelf: 'center',
  display: 'flex',
  color: 'rgba(0,0,0,0.7)',
  width: '100%',
  alignItems: 'center',
  fontWeight: 500,
  letterSpacing: '-0.154',
}
const ACTIVE_LINK_TOP: React.CSSProperties = {
  textDecoration: 'none',
  alignSelf: 'center',
  alignItems: 'center',
  display: 'flex',
  width: '100%',
  color: color.blue,
  fontSize: 14,
  fontWeight: 600,
  height: '100%',
}
const LEFT_BORDER: React.CSSProperties = {
  backgroundColor: color.palette.blueLink,
  width: 4,
  height: 32,
  borderTopRightRadius: 100,
  borderBottomRightRadius: 100,
  marginRight: 16,
}
const LIST: React.CSSProperties = {
  listStyleType: 'none',
  position: 'absolute',
  padding: 0,
  margin: 0,
  height: 70,
  borderTop: '1px solid #EFF0F6',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  display: 'flex',
  width: '100%',
}
const NAV: React.CSSProperties = {
  zIndex: 997,
  width: '100%',
  height: 70,
  backgroundColor: '#FFFFFF',
  position: 'fixed',
  bottom: 0,
}
